import {Control} from 'ol/Control';
import {UI} from './ui';
import {NSStreetView} from './street_view';
//import FullScreenIcon from 'bootstrap-icons/icons/fullscreen.svg?raw'
import StreetViewIcon from '/images/common/street_view.svg?raw';

import { NSPageLabels } from './page_labels';

export class StreetViewModeControl extends Control {
    element = null;

    b_street_view_active = null;
    
    constructor(opt_options) {
        const options = opt_options || {};

        const enterStreetViewModeButton = document.createElement('button');
        enterStreetViewModeButton.title = NSPageLabels.f_get_label_text_by_internal_name('street_view_mode');
        enterStreetViewModeButton.type = 'button';
        enterStreetViewModeButton.innerHTML = StreetViewIcon;

        enterStreetViewModeButton.onclick = () => {
        //enterStreetViewModeButton.classList.add('d-none');

        this.b_street_view_active = !this.b_street_view_active;

        if(this.b_street_view_active)
        {
            // visualy deactivate button by setting it's color to blue?
            enterStreetViewModeButton.classList.add("active");
            // do logic stuff
            //alert("Ligar SV!");
            NSStreetView.f_enable();
            
        }
        else
        {
            // visualy activate button by setting it's color to white?
            enterStreetViewModeButton.classList.remove("active");
            // do logic stuff
            //alert("Desligar SV!");
            NSStreetView.f_disable();
        }

        
        }

        //On mouserover sets beahaviour to highlight image, set background to light transparent color?

        const element = document.createElement('div');
        element.className = ' ol-streetview-mode ol-unselectable ol-control';
        element.appendChild(enterStreetViewModeButton);

        super({
        element: element,
        target: options.target,
        });

        this.element = element;
        this.b_street_view_active = false;
    }
  }